import React from 'react';

const Drawer = ({ isOpen, onClose, children }) => {
    return (
        <div className={`fixed inset-0 z-50 transition-transform transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} bg-white shadow-lg`}>
            <div className="absolute top-0 right-0 p-4">
                <button onClick={onClose} className="text-red-500 text-xl">&times;</button>
            </div>
            <div className="p-6 overflow-y-auto h-full">
                {children}
            </div>
        </div>
    );
};

export default Drawer; 